"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversationRoutes = void 0;
const conversationActions_openapi_1 = require("./conversationActions.openapi");
exports.conversationRoutes = [
    {
        name: 'conversation.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.list']
        }
    },
    {
        name: 'conversation.for-user',
        path: '/for-user/:id',
        method: 'GET',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.for-user']
        }
    },
    {
        name: 'conversation.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.get']
        }
    },
    {
        name: 'conversation.new',
        path: '/new',
        method: 'GET'
    },
    {
        name: 'conversation.get-chat',
        path: '/chat/:id',
        method: 'GET',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.get-chat']
        }
    },
    {
        name: 'conversation.share',
        path: '/share/:uid',
        method: 'GET',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.share']
        }
    },
    {
        name: 'conversation.add_share_user',
        path: '/user-share',
        method: 'POST',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.add_share_user']
        }
    },
    {
        name: 'conversation.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.delete']
        }
    },
    {
        name: 'conversation.toggle-favorite',
        path: '/favorite/:id',
        method: 'POST',
        plugins: {
            openapi: conversationActions_openapi_1.conversationOpenApiDocs['conversation.toggle-favorite']
        }
    }
];
